import styles from "./index.module.css";
interface Props {
  mobilePhone: string | number;
}

export const ForeignMobilePhone = ({ mobilePhone }: Props) => {
  return <span className={`${styles.mobilePhone} piiData`}>{mobilePhone}</span>;
};
